
import { UnitGrams } from '@/entity/entity'
import Vue from 'vue'

export default Vue.extend({
  name: 'IngredientForm',
  props: {
    id: {
      type: String,
      required: true
    },
    defaultGrams: Number,
    defaultOrigin: String,
    unitGrams: {
      type: Object as () => UnitGrams,
      required: true
    }
  },
  data: function () {
    return {
      grams: this.defaultGrams ?? 0,
      origin: this.defaultOrigin ?? '不明'
    }
  },
  created: function () {
    this.emitUpdated()
  },
  updated: function () {
    this.emitUpdated()
  },
  computed: {
    unitGram: function () : {
      name: string,
      value: number
      } | null {
      return this.unitGrams[this.id] ?? null
    }
  },
  methods: {
    setUnitGrams: function () {
      if (!this.unitGram) return
      this.grams = this.unitGram.value
    },
    emitUpdated: function () {
      this.$emit('updated', {
        grams: +this.grams,
        origin: this.origin
      })
    }
  }
})
